export const DEFAULT_WITHDRAWAL_RATE = 0.04;   // 4% rule
export const DEFAULT_ANNUAL_RETURN_RATE = 0.07; // 7% real return
export const FIRE_PROJECTION_MAX_YEARS = 50;
export const FIRE_ASSUMPTIONS_STORAGE_KEY = 'fireAssumptions';
